import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';
import { PanelModule } from 'primeng/panel';
import { HbSharedModule } from '../shared/hb-shared.module';
import { HbSharedUiModule } from '../shared/ui/hb-shared-ui.module';
import { LicenceModuleDisplayNameProvider } from '../viewmodels/LicenceModules';
import { LicensingDialogComponent } from './licensing-dialog.component';
import { LicensingComponent } from './licensing.component';

@NgModule({
  imports: [
    CommonModule,
    HbSharedModule,
    HbSharedUiModule,
    PanelModule,
    I18NextModule,
  ],
  declarations: [
    LicensingComponent,
    LicensingDialogComponent,
  ],
  exports: [
    LicensingComponent,
  ],
  bootstrap: [
    LicensingDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    LicenceModuleDisplayNameProvider,
    {
      provide: I18NEXT_NAMESPACE,
      useValue: ['module.licensing', 'module.dashboard'],
    },
  ],
})
export class LicensingModule { }
